import React, { useEffect, useRef } from "react";
import { trackAddToCart, handleCTAClick } from "../DataLayer";
const Constants = require("../constants.json");

const CartCtaButton = ({ billingPlan, item}) => {
    const cartCtaRef = useRef(null);

    useEffect(() => {
        const handleAddToCart = () => {
            trackAddToCart(item?.sku, item?.name, item?.price);
            handleCTAClick("button", "add to cart");
        };

        const cartCtaElement = cartCtaRef.current;
        if (cartCtaElement) {
            cartCtaElement.addEventListener("click", handleAddToCart);
        }

        return () => {
            if (cartCtaElement) {
                cartCtaElement.removeEventListener("click", handleAddToCart);
            }
        };
    }, []);

    return (
        <div className="cart" style={{ width: "154px" }}>
            <cart-cta
                ref={cartCtaRef}
                products={`[{"sku":"${Constants.vetSku}", "qty": 1, "billingPlan": "${billingPlan}"}]`}
                promo=""
                show-popup="false"
                navigate-on-added="cart"
                locale="en-us"
                site="vet"
                title="Get Started"
                button-color="#fff"
                theme-styles='{
                    "color": "#fff",
                    "bg": "#dd7153",
                    "bg-hover": "none",
                    "hover-color": "#dd7153",
                    "border": "2px solid #dd7153",
                    "border-radius": "3px",
                    "font-family": "\"Nunito Sans\", sans-serif",
                    "font-size": "18px",
                    "font-weight": "700",
                    "line-height": "20px",
                    "hover-color": "#dd7153"
                }'>
            </cart-cta>  
        </div>
    );
};

export default CartCtaButton;
